var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ingredient-color-box",style:({ backgroundColor: ("var(--u-color-" + _vm.name + ")") })})}
var staticRenderFns = []

export { render, staticRenderFns }